import { bool, string } from "prop-types";
import { PureComponent } from "react";

class SetScriptFromSrc extends PureComponent {
  get scriptId() {
    const { src } = this.props;
    return encodeURIComponent(src);
  }

  loadScript = () => {
    const { src, async } = this.props;
    const id = this.scriptId;
    if (!document.getElementById(id)) {
      const el = document.createElement("script");
      el.src = src;
      el.id = id;
      el.async = Boolean(async);
      document.body.appendChild(el);
    }
  };

  deleteScript = () => {
    const el = document.getElementById(this.scriptId);
    if (el) {
      el.remove();
    }
  };

  componentDidMount = () => {
    this.loadScript();
  };

  componentWillUnmount = () => {
    this.deleteScript();
  };

  render = () => null;
}

SetScriptFromSrc.propTypes = {
  src: string.isRequired,
  async: bool,
};

SetScriptFromSrc.defaultProps = {
  async: false,
};

export default SetScriptFromSrc;
